@if (settingsStore.state$ | async; as state) {
    @if (countryLanguagePairs$ | async; as countryLanguagePairs) {
        @if (countryLanguagePairs?.length! > 1) {
            <button
                mat-button
                [matMenuTriggerFor]="countryLanguagesOptions"
                (click)="chevronIcon = 'expand_less'"
                data-testid="country-language-switcher-button"
            >
                {{ state.locale | languageCode | uppercase }}
                <mat-icon>{{ chevronIcon }}</mat-icon>
            </button>
        } @else {
            <span class="locale" data-testid="country-language-switcher-locale">
                {{ state.locale | languageCode | uppercase }}
            </span>
        }
        <mat-menu #countryLanguagesOptions="matMenu" (closed)="chevronIcon = 'expand_more'">
            @for (pair of countryLanguagePairs; track pair) {
                <button mat-menu-item (click)="settingsStore.changeLocale(pair.locale)" [attr.data-testid]="pair.locale + '-button'">
                    <div class="flex items-center gap-2" [class.selected-locale]="state.locale === pair.locale">
                        <span class="flag flag-{{ pair.locale | countryCode }}"></span>
                        {{ languageCountryType[pair.locale] | translate }}
                    </div>
                </button>
            }
        </mat-menu>
    }
}
